import { memo, useContext } from 'react';
import { formatCurrency } from '@atc/string-fns';
import { useElementObserver } from '@atc/use-element-observer';
import CalculatorInput from './CalculatorInput.js';
import TradeInfoInputs from './TradeInfoInputs.js';
import ConfigContext from '../../ConfigContext/ConfigContext.js';
import SelectButtonContainer from './SelectButtonContainer.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
function CashTab(_ref) {
  let {
    formattedTotalPrice,
    inputProps,
    renderTaxesAndFees,
    showOfferPrice,
    tradeInfoInputProps,
    previousCompletedInput
  } = _ref;
  const {
    disableTrade,
    enableNegotiation
  } = useContext(ConfigContext) ?? {};
  const [containerElement, containerRef] = useElementObserver();
  const negotiableOfferLabel = showOfferPrice ? 'Offer Price' : 'Listing Price';
  const listingPriceChildren = /*#__PURE__*/jsx(CalculatorInput, {
    name: "offerPriceInput",
    label: negotiableOfferLabel,
    inputProps: inputProps,
    value: formattedTotalPrice,
    supportingLink: false,
    tabName: "cash",
    showTextField: !enableNegotiation
  }, "offerPriceInput");
  const tradeInChildren = !disableTrade && /*#__PURE__*/jsx(TradeInfoInputs, {
    ...tradeInfoInputProps,
    inputProps: inputProps,
    tabName: "cash"
  });
  const calcInputs = [];
  const tradeInCalcInput = {
    analyticProps: {
      cmp: 'nds_trade-in',
      userModified: 'TRADE_IN_VALUE_CHANGED'
    },
    children: tradeInChildren,
    containerElement,
    heading: 'Trade-In',
    inputCompletedState: previousCompletedInput === 'tradeInInput',
    position: 'right',
    primaryLabel: 'Trade-In',
    secondaryLabel: formatCurrency(tradeInfoInputProps.valueTradeIn - tradeInfoInputProps.valueOwed || 0),
    ...(!enableNegotiation && {
      width: 'full'
    })
  };

  // Add trade-in to the back of the array if trade is not disabled
  if (!disableTrade) {
    calcInputs.push(tradeInCalcInput);
  }
  return /*#__PURE__*/jsxs(Fragment, {
    children: [!enableNegotiation && listingPriceChildren, /*#__PURE__*/jsxs("div", {
      className: "row margin-bottom-1",
      ref: containerRef,
      children: [enableNegotiation && /*#__PURE__*/jsx("div", {
        className: disableTrade ? 'col-xs-12' : 'col-xs-6',
        children: listingPriceChildren
      }), /*#__PURE__*/jsx(SelectButtonContainer, {
        calcInputs: calcInputs
      })]
    }), renderTaxesAndFees('cash')]
  });
}
var CashTab$1 = /*#__PURE__*/memo(CashTab);
export { CashTab$1 as default };
